import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetCorporateVolumesQuery } from '../store/services';
import VolumesList from '../../partial/volumes/list';
import { RiskScoreClientTypeEnum } from '../../types';

import cn from '../corporate-clients-risk.module.css';

const CorporateVolumes = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const {
    corporateClientsRisk: {
      volumes: {
        list: { values },
      },
    },
  } = useAppSelector((state) => state);

  const [getICorporateVolumes, { isLoading, isFetching }] =
    useLazyGetCorporateVolumesQuery();

  useEffect(() => {
    let title = 'Corporate Volumes risk';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content;

  if (isLoading) {
    content = (
      <div className={cn.volumesLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <VolumesList
        getList={getICorporateVolumes}
        isLoading={isLoading}
        isFetching={isFetching}
        values={values}
        type={RiskScoreClientTypeEnum.CORPORATE}
      />
    );
  }

  return (
    <div className={cn.volumesBottom}>
      <div className={cn.volumesTableWrapper} ref={scrollRef}>
        {content}
      </div>
      <Outlet />
    </div>
  );
};

export default CorporateVolumes;
